window.theme = window.theme || {}

theme.searchSpotlight = function () {
    let timeOut;

    $(document).on('keyup focus','.input-search',function(e){
        let parent = $(this).parent();
        console.log();
        const _this = $(this),
            headerSpotlightSearch   = parent.find('.header__menu--search--spotlight-search'),
            element                 = headerSpotlightSearch.find('.sportlight-search'),
            value                   = _this.val();
        headerSpotlightSearch.addClass('is-active');
        if(timeOut) {
            clearTimeout(timeOut);
        }
        if(value.length !== 0) {
            if(!element.hasClass('is-search')){
                element.addClass('is-search');
                element.html(`<div class="loading-data"></div>`);
            }

            timeOut = setTimeout(function(e){
                theme.handleSearchSpotlight(element,value,function(){
                    element.removeClass('is-search');
                });
            },500);
        } else {
            element.removeClass("is-searching");
            element.empty();
            $('<div class="spotlight__title"><span class="title">Tìm kiếm nhiều nhất</span><span class="line"></span></div><div class="spotlight__content spotlight__searched" id="spotLightSearchHistory"></div>')
                .appendTo(element);
            theme.searchHistory();
        }
    });

    $(window).scroll(function() {
        const headerSpotlightSearch = $('.header__menu--search--spotlight-search');
        if(headerSpotlightSearch.hasClass('is-active')){
            headerSpotlightSearch.removeClass('is-active');
        }
    })
}

theme.handleSearchSpotlight = function (element, value, callback) {
    let url = window.FleetCart.baseUrl + '/searchresult';
    $.ajax({
        url: url,
        type: "get",
        data: {
            keyword: value,
            ajax: true
        },
        dataType: 'json'
    }).done(function(res) {
        const {html,success} = res;
        if(success && html) {
            element.html(html);
            let keywords = localStorage.getItem("search_keywords");
            if(!keywords) keywords = [];
            else keywords = JSON.parse(keywords);

            if(value) {
                keywords.unshift(value);
                if(keywords.length > 5) keywords.pop();
                localStorage.setItem("search_keywords", JSON.stringify(keywords));
            } else theme.searchHistory();

            if(typeof callback === 'function'){
                callback();
            }
        }
    })
}

theme.searchHistory = function () {
    var keywords = localStorage.getItem("search_keywords");
    if (keywords) keywords = JSON.parse(keywords);
    var wrapper = $(".spotlight__searched");
    wrapper.empty();
    if (keywords === null) {
        $('.header__menu--search--spotlight-search').removeClass('is-active');
        return;
    }
    keywords.forEach(function (item, key) {
        let itemEl = $('<a href="' + encodeURI("/searchresult?keyword=" + item) + '" class="sportlight-search__item">' +
            '<div class="sportlight-search__thumbnail"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.999 511.999">' +
            '<path d="M225.773.616C101.283.616 0 101.622 0 225.773S101.284 450.93 225.773 450.93s225.774-101.006 225.774-225.157S350.263.616 225.773.616zm0 413.301c-104.084 0-188.761-84.406-188.761-188.145 0-103.745 84.677-188.145 188.761-188.145s188.761 84.4 188.761 188.145c.001 103.739-84.676 188.145-188.761 188.145z"/>'+
            '<path d="M506.547 479.756L385.024 358.85c-7.248-7.205-18.963-7.174-26.174.068-7.205 7.248-7.174 18.962.068 26.174l121.523 120.906a18.457 18.457 0 0013.053 5.385 18.45 18.45 0 0013.121-5.453c7.205-7.249 7.174-18.963-.068-26.174z"/>' +
            '</svg></div>'+
            '<div class="content">'+ item +'</div>'+
            '</a>');
         itemEl.appendTo(wrapper);
     });
};

theme.addAriaLabels = function (event) {
    let dots = $(event.target).find('.owl-dot');
    dots.each(function(index) {
        $(this).attr('aria-label', 'Slide ' + (index + 1));
    });
}

theme.init = function () {
    $(document).ready(function () {
        $('form.contact-form').each(function(i, obj) {
            $(obj).validate({
                rules: {
                    name: {
                        required: true,
                    },
                    phone: {
                        required: true,
                        phoneVN: true
                    }
                },
                messages: {
                    phone: {
                        required: "Vui lòng nhập số điện thoại.",
                        phoneVN: "Vui lòng nhập số điện thoại hợp lệ."
                    },
                    name: {
                        required: "Vui lòng nhập họ tên.",
                    }
                }
            });
        });

        let objFunc = {
            removeError: function () {
                $('div.alert-wrapper').html('');
            },
            showError: function (xhr) {
                this.removeError();
                //
                let messages = [];
                let responseJSON = 'responseJSON' in xhr ? xhr.responseJSON : JSON.parse(xhr.responseText);
                if ('errors' in responseJSON) {
                    Object.values(responseJSON.errors).forEach(function (items) {
                        items.forEach(function (message) {
                            messages.push(message);
                        });
                    });
                } else {
                    messages.push(responseJSON.message);
                }
    
                if (messages.length < 1) {
                    return;
                }
                let alertBox = `<div class="alert alert-danger" role="alert">
            <ul class="error">
            ${messages.map(function (message) {
                    return `<li>${message}</li>`;
                }).join('')}
            </ul>
        </div>`;
    
                $('div.alert-wrapper').append(alertBox);
            }
        }

        $.validator.addMethod("phoneVN", function (value, element) {
            var phoneRegex = /^(0|\+84)(\s|\.)?((3[2-9])|(5[689])|(7[06-9])|(8[1-689])|(9[0-46-9]))(\d)(\s|\.)?(\d{3})(\s|\.)?(\d{3})$/;
    
            if (value.includes('(') && value.includes(')')) {
                value = value.replaceAll('(', '')
                value = value.replaceAll(')', '')
            }
            return this.optional(element) || phoneRegex.test(value);
        }, "Vui lòng nhập số điện thoại hợp lệ.");

        //
        $('.js-submit_form').on('click', function () {
            let eleButton = $(this);
            window.setLoading(eleButton[0], 20, 'var(--color-secondary)', false);
            let form = $(this).closest('.contact-form');
            let valid = typeof $.fn.validate == 'undefined' ? form[0].reportValidity() : form.valid();
            if (!valid) {
                let firstInput = form.find('input.error, select.error').first();
                if (firstInput.length > 0) {
                    $('html').animate({
                        scrollTop: firstInput.offset().top - 100
                    }, 200);
                }

                window.hideLoading(eleButton[0], '', false);
                return false;
            }

            window.setLoading(eleButton[0], 20, 'var(--color-secondary)', false);
        
            let formData = form.serializeArray();
            $.ajax({
                method: "POST",
                url: form.attr('action'),
                data: formData,
            }).then(function (response) {
                console.log(response);
                objFunc.removeError();
                window.location.href = window.FleetCart.urlThankYou;
            }).fail( function(xhr, textStatus, errorThrown) {
                objFunc.showError(xhr);
                window.hideLoading(eleButton[0], '', false);
                return false;
            });
            
        });

    });

    $('.js-featured-related').css('display', 'block')
    $('.js-featured-related').css('max-height', 'unset')
    $('.js-featured-related').slick({
        dots: false,
        rows: 1,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: $('.section-featured-gifts__arrow-left'),
        nextArrow: $('.section-featured-gifts__arrow-right'),
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.js-featured-gifts').css('display', 'block')
    $('.js-featured-gifts').css('max-height', 'unset')
    $('.js-featured-gifts').slick({
        dots: false,
        rows: 1,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow: $('.section-featured-gifts__arrow-left'),
        nextArrow: $('.section-featured-gifts__arrow-right'),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });

    $('.featured-partners').css('display', 'block')
    $('.featured-partners').css('max-height', 'unset')
    $('.featured-partners').slick({
        dots: false,
        rows: 1,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 5000,
        prevArrow: $('.section-partner__arrow-left'),
        nextArrow: $('.section-partner__arrow-right'),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    prevArrow: '',
                    nextArrow: '',
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    prevArrow: '',
                    nextArrow: '',
                    dots: true,
                    onInitialized: theme.addAriaLabels,
                }
            }
        ]
    });

    $('.featured-points').slick({
        lazyLoad: 'ondemand',
        prevArrow: $('.section-point__arrow-left'),
        nextArrow: $('.section-point__arrow-right'),
        dots: false,
        autoplay: true,
        autoplaySpeed: 3000,
    });

    theme.searchSpotlight();
}

// Initialize theme's functions
$(theme.init)